module.exports = __webpack_public_path__ + "static/img/phone-MX.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-MX.png
// module id = 5pVQ
// module chunks = 1